import {css} from '@emotion/react';
import styled from '@emotion/styled';

import {HotelBox} from '@/components/HotelBox';

type Props = {
  hidden: boolean;
};

export const Container = styled.div<Props>(
  ({hidden}) => css`
    ${hidden &&
    css`
      display: none;
    `}

    ${HotelBox} {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
  `
);
